import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAlternateAddressDetailsUrl } from "../utils/urlHelper";

const alternateAddressApi = createApi({
  reducerPath: "alternateAddress",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  endpoints: (builder) => {
    return {
      addAlternateAddress: builder.mutation({
        query: (body) => ({
          url: getAlternateAddressDetailsUrl("alternate_address_details"),
          method: "POST",
          body,
        }),
      }),

      pincodeDetails: builder.query({
        query: (pincode) => ({
          url: getAlternateAddressDetailsUrl(`pincode_details/${pincode}`),
          method: "GET",
        }),
      }),
    };
  },
});

export const { useAddAlternateAddressMutation, usePincodeDetailsQuery } = alternateAddressApi;

export { alternateAddressApi };
